import { dispatchTrackingEventGA4 } from './dispatchTrackingEventGA4';

export enum HomeClubSectionEventName {
  Click = 'homeclub-section_click',
}

export enum HomeClubSectionEventPlacement {
  Inline = 'inline',
  Modal = 'modal',
  Drawer = 'drawer',
}

export enum HomeClubSectionEventMessage {
  Success = 'success',
  Failure = 'failure',
}

export enum HomeClubSectionEventInteraction {
  Close = 'close',
  ShowQrCode = 'show_qr_code',
  SaveBirthday = 'save_birthday',
  LeaveHomeClub = 'leave_homeCLUB',
}

export enum HomeClubSectionEventElement {
  Button = 'button',
  Icon = 'icon',
}

interface DispatchHomeClubSectionClickEventParams {
  element?: string;
  button_text?: string;
  event_message?: HomeClubSectionEventMessage;
  placement?: HomeClubSectionEventPlacement;
  interaction?: HomeClubSectionEventInteraction;
  eventName?: string;
  title?: string;
}

interface TrackingEvent {
  eventName?: string;
  buttonLabel: string;
  title?: string;
}

export const dispatchHomeClubSectionClickEvent = ({
  element = HomeClubSectionEventElement.Button,
  event_message,
  button_text,
  placement,
  eventName = HomeClubSectionEventName.Click,
  interaction,
  ...rest
}: DispatchHomeClubSectionClickEventParams) =>
  dispatchTrackingEventGA4({
    event: eventName,
    element,
    ...(button_text && { button_text }),
    ...(event_message && { event_message }),
    ...(placement && { placement }),
    ...(interaction && { interaction }),
    ...rest,
  });

export const dispatchSuccessTrackingEvents = ({ eventName, buttonLabel, ...rest }: TrackingEvent) =>
  dispatchHomeClubSectionClickEvent({
    eventName,
    button_text: buttonLabel,
    placement: HomeClubSectionEventPlacement.Modal,
    event_message: HomeClubSectionEventMessage.Success,
    ...rest,
  });

export const dispatchFailureTrackingEvent = ({ eventName, buttonLabel, ...rest }: TrackingEvent) =>
  dispatchHomeClubSectionClickEvent({
    eventName,
    button_text: buttonLabel,
    placement: HomeClubSectionEventPlacement.Modal,
    event_message: HomeClubSectionEventMessage.Failure,
    ...rest,
  });
